import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "pianoconticegroups",
    defaultRoutePath: "/incomestatements/pianoconticegroup",
    menuItemScope: "legalentities",
    menuItemName: "pianoconticegroups",
    routes: [
        {
            path: "/incomestatements/pianoconticegroup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
